import React from 'react'
import Skeleton from 'react-loading-skeleton'

function PostWithContentSkeleton() {
    return (
        <div className="text11-content">
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <Skeleton height={`2em`} />
            <div className="social-share-blog mt-5">
                <ul className="column3 tags m-0 p-0">
                    <li>
                        <p className="m-0 mr-sm-4 mr-2">Tags :</p>
                    </li>
                    <li><a href={`/hashtag/`} className="btn-small"><Skeleton /></a></li>
                    <li style={{ marginLeft: `2.7em` }}><a href={`/hashtag/`} className="btn-small"><Skeleton /></a></li>
                </ul>

                <ul className="column3 social m-0 p-0">
                    <li><p className="m-0 mr-sm-4 mr-2">Share this post :</p></li>
                    <li><a href={`/`} className="facebook"><Skeleton /></a></li>
                    <li><a href={`/`} className="facebook"><Skeleton /></a></li>
                </ul>

            </div>

            <div className="new-posts clearfix">
                <a className="prev-post pull-left" href="#prev"><span className="fa fa-arrow-left" aria-hidden="true" />Previous Post</a>
                <Skeleton style={{ marginTop: `1.3em` }} width={`1.5em`} className="next-post pull-right" />
            </div>
        </div>
    )
}

export default PostWithContentSkeleton
